<template>
  <div>
    <v-list-item>
      <v-list-item-action>
        <v-icon class="text-lesson-edit-list-element__drag-questions">mdi-swap-vertical</v-icon>
      </v-list-item-action>

      <v-list-item-content>
        <v-list-item-title v-text="question.text"></v-list-item-title>
      </v-list-item-content>

      <v-list-item-action>
        <v-btn color="teal" dark @click="showUpdateForm = true">
          <v-icon left>mdi-pencil</v-icon>
          Edytuj
        </v-btn>
      </v-list-item-action>

      <v-list-item-action>
        <v-dialog v-model="deleteDialog" persistent max-width="350">
          <template v-slot:activator="{ on }">
            <v-btn color="red" dark v-on="on">
              <v-icon left>mdi-delete</v-icon>
              Usuń
            </v-btn>
          </template>
          <v-card>
            <v-toolbar color="warning" dark flat>
              <v-toolbar-title>Ostrzeżenie</v-toolbar-title>
            </v-toolbar>
            <v-card-text class="mt-4">
              <p>Czy na pewno chcesz usunąć ten element?</p>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="text--secondary" text @click="deleteDialog = false">Nie</v-btn>
              <v-btn color="warning" text @click="removeQuestion">Tak</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-list-item-action>
    </v-list-item>

    <QuestionEditForm
      :show="showUpdateForm"
      :question-to-edit="questionToEdit"
      title="Aktualizuj pytanie"
      @close="updateFormClose"
      @updated="updateQuestion"
    />
  </div>
</template>

<script>
import QuestionEditForm from '@/components/manage/courses/right-panel/lesson-edit/test-lesson/QuestionEditForm.vue';

export default {
  components: {
    QuestionEditForm
  },
  props: {
    question: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    }
  },
  data: function() {
    return {
      showUpdateForm: false,
      questionToEdit: { ...this.question },
      deleteDialog: false
    };
  },
  watch: {
    showUpdateForm(value) {
      if (value) {
        this.$emit('disableOutsideClick');
      } else {
        this.$emit('enableOutsideClick');
      }
    },
    deleteDialog(value) {
      if (value) {
        this.$emit('disableOutsideClick');
      } else {
        this.$emit('enableOutsideClick');
      }
    }
  },
  methods: {
    updateFormClose() {
      this.showUpdateForm = false;
    },
    updateQuestion(ev) {
      this.$emit('update', { question: ev.question });
    },
    removeQuestion() {
      this.$emit('remove', { question: this.question });
      this.deleteDialog = false;
    }
  }
};
</script>

<style lang="scss">
.text-lesson-edit-list-element__drag-questions {
  cursor: pointer;
}
</style>
